import { atom, useAtom } from "jotai";

import { UnionIcon } from "@design-lab/entities/quality-tabs";
import { transfersManagerAtom } from "@design-lab/entities/transfers-lab";
import { trackRemoveBackgroundClicked } from "@design-lab/shared/lib/analytics";
import { Button, Switch } from "@design-lab/shared/ui";
import { JiffyLogoTransfersLab } from "../icons/JiffyLogoTransfersLab";

// Local state to track background preference
export const transfersBackgroundPreferenceAtom = atom<boolean>(true); // true = show with background, false = remove background

export function TransfersRemoveBackground() {
  const [state] = useAtom(transfersManagerAtom);
  const [backgroundPreference, setBackgroundPreference] = useAtom(
    transfersBackgroundPreferenceAtom
  );

  const { items, selectedId } = state.context;
  const selectedItem = items.find((item: any) => item.id === selectedId);
  const selectedSnapshot = selectedItem?.getSnapshot();
  const artwork = selectedSnapshot?.context.artwork;

  const hasBackgroundRemoved = Boolean(artwork?.noBgUrl || artwork?.noBgNoTrimUrl);

  const hasWithBackground = Boolean(artwork?.withBgUrl);

  // Only show if we have both versions
  if (!hasBackgroundRemoved || !hasWithBackground) {
    return null;
  }

  const handleRemoveBackgroundToggle = (checked: boolean) => {
    setBackgroundPreference(!checked);

    // Track analytics
    trackRemoveBackgroundClicked({
      source: "canvas",
      printQuality: "PrintPerfect",
      side: "front", // Transfers Lab doesn't have sides
      artworkId: String(artwork?.id || "")
    });
  };

  return (
    <div className="flex h-10 w-full items-center gap-4 rounded-md bg-white p-1 shadow-sm">
      <div
        data-testid="remove-background-button flex items-center gap-2"
        className="relative flex border-none bg-transparent shadow-none"
      >
        <JiffyLogoTransfersLab />
        <div className="mr-2 flex items-center gap-0.5 whitespace-nowrap">Remove Background</div>
        <Switch
          data-testid="remove-background-switch"
          id="remove-background"
          isSelected={!backgroundPreference}
          onChange={handleRemoveBackgroundToggle}
        />
      </div>
      <Button
        type="button"
        data-testid="refine-artwork-button"
        className="bg-cta-gradient hover:bg-cta-gradient-hover flex h-8 cursor-pointer items-center justify-center gap-2 rounded-md border-0 p-1.5 px-3 text-sm text-white"
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          // TODO: Implement refine artwork for Transfers Lab
        }}
      >
        <UnionIcon className="h-4 w-4 text-white" />
        <span>Edit Design</span>
      </Button>
    </div>
  );
}
